import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Building2, Wrench, Clock, Shield, CheckCircle } from "lucide-react";
import { BusinessInquirySection } from "@/components/BusinessInquirySection";

export default function Bedrift() {
  return (
    <Layout>
      <section className="bg-[#3D2314] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 font-display">Kaffemaskinservice for bedrifter i Bergen</h1>
          <p className="text-white/80 max-w-2xl mx-auto">Serviceavtaler, reparasjon og prioritert oppfølging for kafeer, restauranter, bensinstasjoner, hoteller, kontorer og storkjøkken i Bergen og Vestland.</p>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-[#FFF8F0]">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            { icon: Clock, title: "Minimal nedetid", desc: "Prioritert behandling og rask utrykning holder utstyret i drift." },
            { icon: Shield, title: "Faste avtaler", desc: "Forutsigbare servicekostnader med planlagt vedlikehold." },
            { icon: Wrench, title: "Bredt utstyr", desc: "Vi servicerer alt fra kontorets kaffemaskin til profesjonelle espressomaskiner." },
          ].map((c) => (
            <Card key={c.title} className="border-[#D4A574]/20">
              <CardContent className="pt-6 text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#D4A574]/15 mb-4"><c.icon className="h-6 w-6 text-[#3D2314]" /></div>
                <h3 className="font-semibold text-[#3D2314] mb-2">{c.title}</h3>
                <p className="text-sm text-[#1A1A1A]/70">{c.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-[#3D2314] mb-6 text-center font-display">Hva en serviceavtale kan inkludere</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {["Regelmessig avkalking og rengjøring", "Prioritert responstid ved feil", "Fast kontaktperson", "Lånemaskin ved lengre reparasjoner (etter avtale)", "Årlig funksjonskontroll", "Samlefakturering"].map((i) => (
              <div key={i} className="flex items-start gap-2 bg-[#FFF8F0] rounded-lg p-4 border border-[#D4A574]/20"><CheckCircle className="h-4 w-4 text-green-600 mt-0.5 shrink-0" /><span className="text-sm text-[#1A1A1A]/80">{i}</span></div>
            ))}
          </div>
        </div>
      </section>
      <BusinessInquirySection
        source="bedrift"
        title="Kafeer, restauranter og bensinstasjoner i Bergen og Vestland"
        intro="Når kaffemaskinen står, stopper salget. Vi utfører diagnostikk, service og reparasjon av kaffe- og espressomaskiner for bedrifter i Bergen og omegn (Vestland, tidligere Hordaland). Send en kort forespørsel, så tar vi kontakt for å avtale innlevering, henting eller oppmøte."
      />
      <section className="py-12 bg-[#3D2314]">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <Building2 className="h-8 w-8 text-[#D4A574] mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-white mb-4 font-display">Ønsker din bedrift en serviceavtale?</h2>
          <p className="text-white/70 mb-6">Ta kontakt for et uforpliktende tilbud tilpasset deres utstyr og behov.</p>
          <Button asChild size="lg" className="bg-[#D4A574] hover:bg-[#D4A574]/90 text-[#3D2314] font-semibold"><Link to="/kontakt-skjema">Kontakt oss</Link></Button>
        </div>
      </section>
    </Layout>
  );
}
